<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<nav-bar [hideLogo]="true">
	<!-- This section is used to display our Plan information section-->
	<div class="plan-information">
		<h1 automationId="planInfo">
			{{ (planState.project.object$ | async)?.projectName }} -
			<span>{{ (planState.plan.object$ | async)?.view.name }}</span>
		</h1>
		<h2 *ngIf="(planState.plan.object$ | async)?.view.milestone">
			Current plan date: &nbsp;
			{{ dateCache.getFormat(planState.scopeSoup.milestone.scheduleDate, 'MMM D, YYYY') }}
			<span class="interpunct">・</span>
			<span [hidden]="statusHidden$ | async">
				<span *ngIf="planState.scopeSoup.lag && planState.scopeSoup.lag.days > 0">
					{{ planState.scopeSoup.lag.days }} work days
					<span [hidden]="!planState.scopeSoup.lag.behind" class="days-behind"> behind</span>
					<span [hidden]="planState.scopeSoup.lag.behind" class="days-ahead"> ahead</span>
				</span>
				<span *ngIf="planState.scopeSoup.lag && planState.scopeSoup.lag.days <= 0"> On Time </span>
			</span>
			<span
				*ngIf="(planAccessCheck.isAdmin$ | async) && !(statusHidden$ | async)"
				(click)="hidePlanStatus()"
				class="days-toggle"
			>
				Hide</span
			>
			<span
				*ngIf="(planAccessCheck.isAdmin$ | async) && (statusHidden$ | async)"
				(click)="showPlanStatus()"
				class="days-toggle days-toggle-show"
			>
				Show Plan Status</span
			>
		</h2>
		<h2 *ngIf="!(planState.plan.object$ | async)?.view.milestone">Add a Milestone for plan status</h2>
	</div>

	<!-- Profile Menu -->
	<div menuTrigger [matMenuTriggerFor]="menu">
		<div class="nav-bar-account-details">
			<div class="nav-bar-account-name">
				<span class="nav-bar-account-name-wrapper" automationId="navAccountName">{{
					getProjectMemberName((planState.authedProjectMember$ | async)?.view.projectMemberId)
				}}</span
				><i class="material-icons notranslate">keyboard_arrow_down</i>
			</div>
			<div class="nav-bar-account-role">
				<span class="nav-bar-account-role-wrapper" automationId="navAccountRole"
					><span class="select-color-cell no-print {{ planState.scopeSoup.currentRole.$id || '' }}"></span
					>{{
						(planState.scopeSoup.currentRole &&
							planState.scopeSoup.currentRole.data &&
							planState.scopeSoup.currentRole.data.roleName) ||
							'No Role Set'
					}}</span
				>
			</div>
		</div>
		<div class="nav-bar-account-details-mobile">
			<i class="material-icons notranslate">account_circle</i>
		</div>
	</div>
	<mat-menu #menu="matMenu" xPosition="before" class="nav-bar-dropdown-menu nav-bar-dropdown-mat-styling">
		<role-changer
			*ngIf="
				planState.scopeSoup.multipleRolesUtils.countRoles(
					planState.scopeSoup.you.projectMember,
					planState.scopeSoup.roles.fb
				) > 1
			"
			[roleList$]="planState.rolesApi.data.list$"
			[authedProjectMember$]="planState.authedProjectMember$"
			[projectMember]="planState.scopeSoup.you.projectMember"
		></role-changer>
		<!-- SHOW IF ADMIN -->
		<button
			mat-menu-item
			*ngIf="planAccessCheck.isAdmin$ | async"
			class="profile-menu-admin-access"
			automationId="planAdmin"
		>
			ACCESS LEVEL:<span class="profile-menu-admin-access-label">ADMIN</span>
		</button>
		<button mat-menu-item (click)="navigate(['/projects', planState.projectId])" automationId="planInsights">
			<mat-icon>dashboard</mat-icon>Insights
		</button>
		<button
			mat-menu-item
			(click)="analyticsEventsService.wentToProfile(); navigate(['/account', 'profile'])"
			automationId="planAccountsettings"
		>
			<mat-icon>account_circle</mat-icon>Account Settings
		</button>
		<button
			mat-menu-item
			*ngIf="isOrgAdmin$ | async"
			(click)="openAPISettings()"
			automationId="planApisettings"
		>
			<mat-icon>code</mat-icon>{{ appStrings.API_SETTINGS }}
		</button>
		<button mat-menu-item (click)="goToMobile()" automationId="planMobileSite">
			<mat-icon>smartphone</mat-icon>Mobile Site
		</button>
		<button mat-menu-item (click)="logout()" automationId="planLogout">
			<mat-icon>exit_to_app</mat-icon>Log Out
		</button>
	</mat-menu>

	<support-menu class="support-menu-container no-print"></support-menu>

	<!-- Plan Actions Menu (Appears for normal sized screens) -->
	<dropdown-menu
		#planActions
		(onOpen)="hideAttachments(); registerPlanActionsMenu(planActions)"
		class="plan-actions-menu-container no-print"
	>
		<div dropdown-label>
			<div
				data-testing-locator="plan-actions-toggle"
				class="nav-bar-menu-item"
				[ngClass]="{ 'nav-bar-menu-item-expanded': planActions.opened$ | async }"
				automationId="planActionsTopMenu"
			>
				Plan actions<span class="nav-bar-menu-dropdown-icon"
					><i class="material-icons notranslate">keyboard_arrow_down</i></span
				>
			</div>
		</div>
		<div dropdown-content>
			<div class="plan-actions-menu nav-bar-dropdown-menu">
				<!-- [UN]LOCK PLAN Toggle -->
				<div
					class="nav-bar-dropdown-menu-item plan-actions-lock-menu-item"
					automationId="planActionsUnlockPlan"
					(click)="
						!planState.scopeSoup.accessChecker.generic(
							'Your project has been archived',
							!planAccessCheck.isProjectDisabledSync()
						) || unlockPlan()
					"
					*ngIf="
						(planAccessCheck.isAdmin$ | async) &&
						(planAccessCheck.hasRestrictedAccess$ | async) &&
						(planAccessCheck.accessLevel$ | async) !== PlanAccessLevel.archived
					"
				>
					<i class="material-icons notranslate">lock_outline</i>Unlock plan
				</div>
				<div
					class="nav-bar-dropdown-menu-item plan-actions-unlock-menu-item"
					automationId="planActionsLockPlan"
					(click)="lockPlan()"
					*ngIf="
						(planAccessCheck.isAdmin$ | async) &&
						!(planAccessCheck.hasRestrictedAccess$ | async) &&
						(planAccessCheck.accessLevel$ | async) !== PlanAccessLevel.archived
					"
				>
					<i class="material-icons notranslate">lock_open</i>Lock plan
				</div>

				<!-- DEPENDENCY TOGGLE -->
				<div
					*ngIf="!userPreferenceStateService.showAllDependencies"
					automationId="planActionsShowDependencies"
					class="nav-bar-dropdown-menu-item plan-actions-dependencies-menu-item"
					(click)="planState.scopeSoup.dependencyNotice(); planActions.close()"
				>
					<i class="material-icons notranslate">link</i>Show dependencies
				</div>
				<div
					*ngIf="userPreferenceStateService.showAllDependencies"
					automationId="planActionsHideDependencies"
					class="nav-bar-dropdown-menu-item plan-actions-dependencies-menu-item"
					(click)="planState.scopeSoup.dependencyNotice(); planActions.close()"
				>
					<i class="material-icons notranslate">link</i>Hide dependencies
				</div>

				<!-- PIN HISTORY TOGGLE -->
				<div
					*ngIf="!userPreferenceStateService.showPinHistory"
					automationId="planActionsShowPinHistory"
					class="nav-bar-dropdown-menu-item plan-actions-dependencies-menu-item"
					(click)="showPinHistoryToggle(true); planActions.close()"
				>
					<i class="material-icons">push_pin</i>Show pin history
				</div>
				<div
					*ngIf="userPreferenceStateService.showPinHistory"
					automationId="planActionsHidePinHistory"
					class="nav-bar-dropdown-menu-item plan-actions-dependencies-menu-item"
					(click)="showPinHistoryToggle(false); planActions.close()"
				>
					<i class="material-icons">push_pin</i>Hide pin history
				</div>

				<div
					class="nav-bar-dropdown-menu-item plan-actions-see-all-menu-item"
					automationId="planActionsSeeAllTickets"
					(click)="
						$event.stopPropagation();
						planState.scopeSoup.scaleToFit();
						planState.scopeSoup.dispatchZoomToFitSegment();
						planActions.close()
					"
				>
					<i class="material-icons notranslate">all_out</i>See all tickets
				</div>
				<div
					class="nav-bar-dropdown-menu-item"
					automationId="planActionsPrintPlan"
					(click)="onClickPrintPlan($event)"
				>
					<i class="material-icons notranslate">print</i>Print plan
				</div>
				<div
					class="nav-bar-dropdown-menu-item"
					*ngIf="(planAccessCheck.isAdmin$ | async) && !(planAccessCheck.hasRestrictedAccess$ | async)"
					automationId="planActionsAddSwimLane"
					(click)="$event.stopPropagation(); planState.scopeSoup.addSwimlane(); planActions.close()"
				>
					<i class="material-icons notranslate">playlist_add</i>Add swim lane
				</div>
				<div
					class="nav-bar-dropdown-menu-item"
					*ngIf="(undoEnabled$ | async) && !(planAccessCheck.hasRestrictedAccess$ | async)"
					automationId="planActionsUndoChanges"
					(click)="$event.stopPropagation(); planActions.close(); planState.toggleUndoPanel()"
				>
					<i class="material-icons notranslate">undo</i>Undo changes
				</div>

				<!-- VIEW LABOR TOGGLE -->
				<!-- This option is visible if project crewSizesEnabled is true OR if settings/crewSizesEnabled is true -->
				<div
					*ngIf="(preferences$ | async).crewSizesEnabled && !userPreferenceStateService.showLaborCount"
					class="nav-bar-dropdown-menu-item"
					automationId="planActionsViewCrewSize"
					(click)="viewCrewSizesToggle(true); planActions.close()"
				>
					<i class="material-icons notranslate">bar_chart</i>View crew sizes
				</div>
				<div
					*ngIf="(preferences$ | async).crewSizesEnabled && userPreferenceStateService.showLaborCount"
					class="nav-bar-dropdown-menu-item"
					automationId="planActionsHideCrewSize"
					(click)="
						analyticsEventsService.hideCrewSizes(planState.scopeSoup.plan.$id);
						viewCrewSizesToggle(false);
						planActions.close()
					"
				>
					<i class="material-icons notranslate">bar_chart</i>Hide crew sizes
				</div>

				<!-- Show meeting popup -->
				<div
					*ngIf="!planState.showMeetingPopup && (preferences$ | async).sharedMeeting"
					automationId="planActionsVideoMetting"
					class="nav-bar-dropdown-menu-item plan-actions-dependencies-menu-item"
					(click)="planState.showMeetingPopup = true; planActions.close()"
				>
					<i class="material-icons video-icon">videocam</i>Open video meeting
				</div>

				<!-- Adjust pull ticket width -->
				<div
					class="nav-bar-dropdown-menu-item"
					*ngIf="(planAccessCheck.isAdmin$ | async) && (widePullTicketEnabled$ | async)"
					automationId="planActionsAdjustPullTicketsWidth"
					(click)="openWideTicketChoicesModal()"
				>
					<i class="material-icons notranslate">aspect_ratio</i>Adjust pull ticket width
				</div>

				<!-- HOVER OVER TOGGLE -->
				<div
					*ngIf="isPlanActionsHoverOverEnabled$ | async"
					automationId="planActionsHoverOver"
					class="nav-bar-dropdown-menu-item"
					(click)="onToggleHoverOver()"
				>
					<i class="material-icons notranslate">flip_to_front</i>
					{{
						(isHoverOverEnabled$ | async)
							? appStrings.PLAN_ACTION_DISABLE_HOVER_OVER
							: appStrings.PLAN_ACTION_ENABLE_HOVER_OVER
					}}
				</div>

				<!-- Import Ticket Menu Item -->
				<ng-container *ngTemplateOutlet="importTicketsMenuItem"></ng-container>

				<!-- Plan Overview Menu Item -->
				<ng-container *ngTemplateOutlet="planOverviewMenuItem"></ng-container>
			</div>
		</div>
	</dropdown-menu>

	<!-- This menu is only visible for small screens -->
	<dropdown-menu
		#planMenuSmall
		class="plan-menu-container no-print"
		(onOpen)="registerPlanActionsMenuSmall(planMenuSmall)"
	>
		<div
			dropdown-label
			class="nav-bar-menu-item"
			ng-class="{ 'nav-bar-menu-item-expanded': planMenuSmall.opened$ | async }"
		>
			<span *ngIf="(intercomService.notificationCount$ | async) > 0" class="support-chat-icon pulsing"></span
			><span class="plan-menu-text-label">Plan Menu</span
			><span class="plan-menu-mobile-icon"><i class="material-icons notranslate">more_vert</i></span>
			<!-- This is the intercom notification count -->
			<span *ngIf="(intercomService.notificationCount$ | async) > 0">
				({{ intercomService.notificationCount$ | async }})
			</span>
			<span class="nav-bar-menu-dropdown-icon"
				><i class="material-icons notranslate">keyboard_arrow_down</i></span
			>
		</div>

		<div dropdown-content class="plan-menu nav-bar-dropdown-menu">
			<div class="plan-menu-labels">PLAN ACTIONS</div>

			<!-- [UN]LOCK PLAN Toggle -->
			<div
				class="nav-bar-dropdown-menu-item plan-actions-unlock-menu-item"
				(click)="
					!planState.scopeSoup.accessChecker.generic(
						'Your project has been archived',
						!planAccessCheck.isProjectDisabledSync()
					) || unlockPlan()
				"
				*ngIf="(planAccessCheck.isAdmin$ | async) && (planAccessCheck.hasRestrictedAccess$ | async)"
			>
				<i class="material-icons notranslate">lock_outline</i>Unlock plan
			</div>
			<div
				class="nav-bar-dropdown-menu-item plan-actions-lock-menu-item"
				(click)="lockPlan()"
				*ngIf="!(planAccessCheck.hasRestrictedAccess$ | async) && (planAccessCheck.isAdmin$ | async)"
			>
				<i class="material-icons notranslate">lock_open</i>Lock plan
			</div>
			<!-- DEPENDENCY TOGGLE -->
			<div
				*ngIf="!userPreferenceStateService.showAllDependencies"
				class="nav-bar-dropdown-menu-item plan-actions-dependencies-menu-item"
				(click)="showAllDependenciesToggle(true); planMenuSmall.close()"
			>
				<i class="material-icons notranslate">link</i>Show dependencies
			</div>
			<div
				*ngIf="userPreferenceStateService.showAllDependencies"
				class="nav-bar-dropdown-menu-item plan-actions-dependencies-menu-item"
				(click)="showAllDependenciesToggle(false); planMenuSmall.close()"
			>
				<i class="material-icons notranslate">link</i>Hide dependencies
			</div>

			<!-- PIN HISTORY TOGGLE -->
			<div
				*ngIf="!userPreferenceStateService.showPinHistory"
				class="nav-bar-dropdown-menu-item plan-actions-dependencies-menu-item"
				(click)="showPinHistoryToggle(true); planMenuSmall.close()"
			>
				<i class="material-icons">push_pin</i>Show pin history
			</div>
			<div
				*ngIf="userPreferenceStateService.showPinHistory"
				class="nav-bar-dropdown-menu-item plan-actions-dependencies-menu-item"
				(click)="showPinHistoryToggle(false); planMenuSmall.close()"
			>
				<i class="material-icons">push_pin</i>Hide pin history
			</div>

			<div
				class="nav-bar-dropdown-menu-item plan-actions-see-all-menu-item"
				(click)="
					$event.stopPropagation();
					planState.scopeSoup.scaleToFit();
					planState.scopeSoup.dispatchZoomToFitSegment();
					planMenuSmall.close()
				"
			>
				<i class="material-icons notranslate">all_out</i>See all tickets
			</div>
			<div class="nav-bar-dropdown-menu-item" (click)="onClickPrintPlan($event)">
				<i class="material-icons notranslate">print</i>Print plan
			</div>

			<div
				class="nav-bar-dropdown-menu-item"
				*ngIf="(planAccessCheck.isAdmin$ | async) && !(planAccessCheck.hasRestrictedAccess$ | async)"
				(click)="$event.stopPropagation(); planState.scopeSoup.addSwimlane(); planMenuSmall.close()"
			>
				<i class="material-icons notranslate">playlist_add</i>Add swim lane
			</div>

			<div
				class="nav-bar-dropdown-menu-item"
				*ngIf="(undoEnabled$ | async) && !(planAccessCheck.hasRestrictedAccess$ | async)"
				(click)="$event.stopPropagation(); planActions.close(); planState.toggleUndoPanel()"
			>
				<i class="material-icons notranslate">undo</i>Undo changes
			</div>

			<!-- VIEW LABOR TOGGLE -->
			<div
				*ngIf="(preferences$ | async).crewSizesEnabled && !userPreferenceStateService.showLaborCount"
				class="nav-bar-dropdown-menu-item"
				(click)="viewCrewSizesToggle(true); planMenuSmall.close()"
			>
				<i class="material-icons notranslate">bar_chart</i>View crew sizes
			</div>
			<div
				*ngIf="(preferences$ | async).crewSizesEnabled && userPreferenceStateService.showLaborCount"
				class="nav-bar-dropdown-menu-item"
				(click)="viewCrewSizesToggle(false); planMenuSmall.close()"
			>
				<i class="material-icons notranslate">bar_chart</i>Hide crew sizes
			</div>

			<!-- WIDE TICKET -->
			<div
				class="nav-bar-dropdown-menu-item"
				(click)="openWideTicketChoicesModal()"
				*ngIf="(planAccessCheck.isAdmin$ | async) && (widePullTicketEnabled$ | async)"
			>
				<i class="material-icons notranslate">aspect_ratio</i>
				<span>{{ appStrings.ADJUST_PULL_TICKET_WIDTH_TITLE }}</span>
			</div>

			<!-- Show meeting popup -->
			<div
				*ngIf="!planState.showMeetingPopup && (preferences$ | async).sharedMeeting"
				class="nav-bar-dropdown-menu-item plan-actions-dependencies-menu-item show-meeting"
				(click)="planState.showMeetingPopup = true; planActions.close()"
			>
				<i class="material-icons video-icon">videocam</i>Open video meeting
			</div>

			<!-- Import Ticket Menu Item -->
			<ng-container *ngTemplateOutlet="importTicketsMenuItem"></ng-container>
			<div class="plan-menu-labels support-label">SUPPORT</div>
			<a [href]="supportMenuLinks.HELP_CENTER" target="_blank" class="nav-bar-dropdown-menu-item">
				<i class="material-icons notranslate">help</i>{{ appStrings.SUPPORT_MENU_HELP_CENTER }}
			</a>
			<div
				class="nav-bar-dropdown-menu-item plan-actions-chat-menu-item"
				(click)="intercomService.toggle(); planMenuSmall.close()"
			>
				<!-- <span ng-show="intercomHandler.notificationCount > 0" class="support-chat-icon pulsing"></span> --><i
					class="material-icons notranslate"
					>chat_bubble_outline</i
				>Live Chat
				<span *ngIf="(intercomService.notificationCount$ | async) > 0"
					>({{ intercomService.notificationCount$ | async }})</span
				>
			</div>
		</div>
	</dropdown-menu>

	<!-- BEGIN PLACEHOLDER REPLACE AS PART OF TP-7317 -->
	<mat-radio-group
		*ngIf="granularEnabledService.isGranularEnabled$ | async"
		[formControl]="granularScaleControl"
		class="granular-scale-control"
	>
		<mat-radio-button [value]="TicketScale.Daily">Daily</mat-radio-button>
		<mat-radio-button [value]="TicketScale.Hourly">Hourly</mat-radio-button>
	</mat-radio-group>
	<!-- END PLACEHOLDER REPLACE AS PART OF TP-7317 -->
	<tp-quick-search class="quick-search-component"></tp-quick-search>
	<!--<div class="clear"></div>-->
</nav-bar>

<ng-template #importTicketsMenuItem>
	<!-- DATA SYNC (IMPORT TICKETS) -->
	<div
		*ngIf="isTicketImportV2Enabled$ | async"
		automationId="ticketImportV2"
		class="nav-bar-dropdown-menu-item"
		(click)="onOpenImportTickets()"
	>
		<i class="material-icons notranslate">file_upload</i>
		{{ appStrings.IMPORT_TICKETS }}
	</div>
</ng-template>

<ng-template #planOverviewMenuItem>
	<div automationId="planOverview" class="nav-bar-dropdown-menu-item" (click)="onOverviewClick()">
		<mat-icon class="overview-icon">insert_chart</mat-icon>
		{{ appStrings.OVERVIEW_MENU }}
	</div>
</ng-template>
